class Tabulator {
  constructor(account, isMembership) {
    this.account = account;
    this.userTabs = ['about', 'rules', 'leaderboard', 'rewards', 'membership', 'activity', 'help'];
    this.visitorTabs = ['about', 'leaderboard', 'rewards', 'membership', 'help'];
    this.isMembership = isMembership;
  }

  getTag(id) {
    return id;
  }

  getTitle(id) {
    return id;
  }

  list() {
    let tabs = this.account ? this.userTabs : this.visitorTabs;
    if (!this.isMembership) tabs = tabs.filter((value) => value !== `membership`);
    return this.account ? tabs.filter((tab) => tab !== 'about') : tabs;
  }

  getActive() {
    const currentTag = window.location.hash.split('#')[1];
    if (this.list().includes(currentTag)) return currentTag;
    if (this.getTag(currentTag) === this.getTag('about')) return currentTag; // This is to handle Voguish page tabs structure
    return this.account ? this.getTag('rules') : this.getTag('about');
  }

  isActive(tag) {
    return this.getActive() === this.getTag(tag);
  }

  onChange(tag) {
    if (window.location.hash !== tag) {
      const currentURL = new URL(window.location);
      currentURL.hash = tag;
      window.history.pushState({}, '', currentURL);
    }
    return this.getActive();
  }
}

export default Tabulator;
